export const SHOWCASE_INTERVAL_MS = 6500;

export const showcaseSlides = [
  {
    id: "cameras", label: "Fotocamere", image: "/images/hero.jpg",
    alt: "Fotocamera e obiettivi di seconda mano", position: "52% 50%",
    eyebrow: "FOTOCAMERE · NUOVE STORIE", intro: "Il bello dell’usato?",
    headline: "Ha ancora tanto da raccontare.",
    feature: "La fiducia viene prima.", detail: "Scopri le regole di sicurezza.",
  },
  {
    id: "lenses", label: "Obiettivi", image: "/images/camera.jpg",
    alt: "Primo piano di un obiettivo fotografico", position: "46% 50%",
    eyebrow: "OBIETTIVI · ALTRE PROSPETTIVE", intro: "Cambia prospettiva.",
    headline: "Non la tua passione.",
    feature: "Dall’annuncio a casa tua.", detail: "Scopri spedizioni e imballaggio.",
  },
  {
    id: "telescopes", label: "Telescopi", image: "/images/hero-telescope.png",
    alt: "Telescopio rifrattore su montatura sotto il cielo al crepuscolo", position: "50% 42%",
    eyebrow: "TELESCOPI · OLTRE L’ORIZZONTE", intro: "Continua a guardare in alto.",
    headline: "Il prossimo sogno è più vicino.",
    feature: "Una passione, più orizzonti.", detail: "Fotografia e astronomia, tra persone.",
  },
] as const;

export function nextShowcaseIndex(current: number, available: readonly number[]) {
  if (available.length === 0) return current;
  const position = available.indexOf(current);
  return available[(position + 1) % available.length];
}

export function shouldRotateShowcase(state: {
  reducedMotion: boolean; manuallySelected: boolean; hovered: boolean;
  focused: boolean; visible: boolean; inView: boolean; availableCount: number;
}) {
  return !state.reducedMotion && !state.manuallySelected && !state.hovered &&
    !state.focused && state.visible && state.inView && state.availableCount > 1;
}
